import _ from 'lodash';
import * as stateUtils from './state';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').ICD10Fixture} ICD10Fixture
 * @typedef {import('./state').PaginationOpts} PaginationOpts
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * @typedef {Object} GetICD10FixturesActionOpts
 * @property {string} searchString
 * @property {number} skip
 * @property {number} limit
 * @property {boolean} $forceFetch - use only for refresh buttons
 *
 * @callback GetICD10FixturesAction
 * @param {ActionContext} ctx
 * @param {GetICD10FixturesActionOpts} opts
 * @returns {Promise<Account>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {GetICD10FixturesAction}
 */
export const getICD10Fixtures = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({ limit: 20 }, stateUtils.DEFAULT_ICD10_PAGINATION_OPTS, opts);
  opts.searchString = _.trim(opts.searchString);
  const paginationOpts = _.pick(opts, 'searchString', 'skip', 'limit');

  // check cache
  if (ctx.state.icd10.length && _.isEqual(ctx.state.icd10PaginationOpts, paginationOpts) && !opts.$forceFetch) {
    return ctx.state.icd10;
  }

  // fetch
  const query = {
    type: 'icd10'
  };
  if (typeof opts.searchString === 'string') {
    query.$or = [
      { code: { $regex: `^${opts.searchString}`, $options: 'i' } },
      { text: { $regex: `^${opts.searchString}`, $options: 'i' } }
    ];
  }
  if (opts.limit) query.$limit = opts.limit;
  if (opts.skip) query.$skip = opts.skip;
  const { items } = await sdk.fixtures().find(query);
  return items;
};
